var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("Open Book Store")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/books"
    }
  }, [_vm._v("All Books")])], 1), _vm._v(" "), (_vm.isAuthenticated) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "/books-self"
    }
  }, [_vm._v("My Collection")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/trades"
    }
  }, [_vm._v("Trade Requests")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [(_vm.isAuthenticated) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("Profile")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])])] : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)]], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f111ef0c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/header.vue
// module id = 102
// module chunks = 0